import {IAquaAdminClient} from "@syginc/tellus-client";

import {AdminApi} from "../api/api";
import {getLinkTitle} from "../utils/get-link-title";
import {createImagefrontOption, ImagefrontTokenProvider} from "../utils/imagefront-util";
import {getBlockDefinitions} from "./admin-client/get-block-definitions";
import {getTemplateDetailDefinitions} from "./admin-client/get-template-detail-definitions";
import {getTemplateListDefinitions} from "./admin-client/get-template-list-definitions";

export function createAquaAdminClient(
    adminApi: AdminApi,
    buildImageFilename: (file: File) => string,
    serverUrl: string,
    assetUrl: string | undefined,
    imagefrontTokenProvider: ImagefrontTokenProvider,
): IAquaAdminClient {
    return {
        getImagefrontOption: () =>
            createImagefrontOption(buildImageFilename, imagefrontTokenProvider),
        getAssetUrl: () => assetUrl,
        getServerUrl: () => serverUrl,
        getLinkTitle: (url) => getLinkTitle(adminApi, url),
        getBlockDefinitions: () => getBlockDefinitions(adminApi),
        getTemplateDetailDefinitions: (templateId: string) =>
            getTemplateDetailDefinitions(adminApi, templateId),
        getTemplateListDefinitions: () => getTemplateListDefinitions(adminApi),
    };
}
